module.exports = "<pplus-border-meter></pplus-border-meter>\r\n"